/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Content editor test definition
 * @export
 * @interface ContentEditorTestDefinitionUpdateResponse
 */
export interface ContentEditorTestDefinitionUpdateResponse {
    /**
     * 
     * @type {number}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    element_id: number;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    points_to_pass: number;
    /**
     * 
     * @type {number}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    time_limit: number;
    /**
     * 
     * @type {number}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    total_points: number;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    show_answers_in_test_result: ContentEditorTestDefinitionUpdateResponseShowAnswersInTestResultEnum;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    test_type: string;
    /**
     * 
     * @type {number}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    points_to_pass_percent: number;
    /**
     * 
     * @type {number}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    test_size: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    enforce_study_of_previous_steps: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    define_question_dependent_steps: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContentEditorTestDefinitionUpdateResponse
     */
    mark_dependent_steps_as_complete: boolean;
}


/**
 * @export
 */
export const ContentEditorTestDefinitionUpdateResponseShowAnswersInTestResultEnum = {
    None: 'none',
    OnlyIncorrect: 'only_incorrect',
    All: 'all'
} as const;
export type ContentEditorTestDefinitionUpdateResponseShowAnswersInTestResultEnum = typeof ContentEditorTestDefinitionUpdateResponseShowAnswersInTestResultEnum[keyof typeof ContentEditorTestDefinitionUpdateResponseShowAnswersInTestResultEnum];


/**
 * Check if a given object implements the ContentEditorTestDefinitionUpdateResponse interface.
 */
export function instanceOfContentEditorTestDefinitionUpdateResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "element_id" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "points_to_pass" in value;
    isInstance = isInstance && "time_limit" in value;
    isInstance = isInstance && "total_points" in value;
    isInstance = isInstance && "show_answers_in_test_result" in value;
    isInstance = isInstance && "test_type" in value;
    isInstance = isInstance && "points_to_pass_percent" in value;
    isInstance = isInstance && "test_size" in value;
    isInstance = isInstance && "enforce_study_of_previous_steps" in value;
    isInstance = isInstance && "define_question_dependent_steps" in value;
    isInstance = isInstance && "mark_dependent_steps_as_complete" in value;

    return isInstance;
}

export function ContentEditorTestDefinitionUpdateResponseFromJSON(json: any): ContentEditorTestDefinitionUpdateResponse {
    return ContentEditorTestDefinitionUpdateResponseFromJSONTyped(json, false);
}

export function ContentEditorTestDefinitionUpdateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentEditorTestDefinitionUpdateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'element_id': json['element_id'],
        'description': json['description'],
        'name': json['name'],
        'points_to_pass': json['points_to_pass'],
        'time_limit': json['time_limit'],
        'total_points': json['total_points'],
        'show_answers_in_test_result': json['show_answers_in_test_result'],
        'test_type': json['test_type'],
        'points_to_pass_percent': json['points_to_pass_percent'],
        'test_size': json['test_size'],
        'enforce_study_of_previous_steps': json['enforce_study_of_previous_steps'],
        'define_question_dependent_steps': json['define_question_dependent_steps'],
        'mark_dependent_steps_as_complete': json['mark_dependent_steps_as_complete'],
    };
}

export function ContentEditorTestDefinitionUpdateResponseToJSON(value?: ContentEditorTestDefinitionUpdateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'element_id': value.element_id,
        'description': value.description,
        'name': value.name,
        'points_to_pass': value.points_to_pass,
        'time_limit': value.time_limit,
        'total_points': value.total_points,
        'show_answers_in_test_result': value.show_answers_in_test_result,
        'test_type': value.test_type,
        'points_to_pass_percent': value.points_to_pass_percent,
        'test_size': value.test_size,
        'enforce_study_of_previous_steps': value.enforce_study_of_previous_steps,
        'define_question_dependent_steps': value.define_question_dependent_steps,
        'mark_dependent_steps_as_complete': value.mark_dependent_steps_as_complete,
    };
}

